// extracted by mini-css-extract-plugin
export var animationContainer = "_em-0";
export var asteriskIcon = "_em-8";
export var conversationLeftSection = "_em-4";
export var conversationListItem = "_em-3";
export var conversationMiddleSection = "_em-5";
export var conversationRightSection = "_em-6";
export var detailsContent = "_em-1";
export var listContainer = "_em-7";
export var modalContent = "_em-2";